<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, getCurrentInstance } from "vue";
import { Globals } from "@/Globals";
import { onShowSite } from "@/NavigationHelper";

import { getKZValueDisplay, getKZValue } from "@/DataHelper";
import { DialogParameter, showDialog, showSnackbar } from "@/UIHelper";
import Constants from "@/Constants";
import BaseEditor from "../../../components/BaseEditor.vue";
import { calcFunctionNew } from "@/CalcHelperStatic";
import BaseVGrid from "@/components/BaseVGrid.vue";
import RkAdminDialogKosten from "@/views/RK/Admin/DialogKosten.vue";
import CalcButton from "@/components/CalcButton.vue";
import { isPhone } from "@/DeviceInfoPlugin";
import {
  globalsStt,
  globalsDruck,
  globalsBezeichnung,
  begriffBezeichnung,
  checkNode,
} from "@/local";
import {
  mountedBase,
  BaseSetup,
  onDelete,
  reloadData,
} from "@/DataLoaderStatic";
import { getSiteData } from "@/NavigationHelper";
const emit = defineEmits(["backDelete", "back", "goBack", "showSite"]);

let day!: Date | null;
let timeLine: boolean = false;
let myHeight: number = 600;
let bezeichnung: string = "";
let memo: string = "";
let showPrint: boolean = false;
let printItems!: ALLDruck[];
let modell: string = "Web_RK_ReiseBerechnen";
let showDialogLocal = ref<boolean>(false);
const siteData = getSiteData();
let items = ref<ListItems[]>([]);
let showCalc = ref<boolean>(false);
let tab = ref<string>("");
let editAzureBeleg = ref<boolean>(false);
let kostenQuery = ref<string>("Web_UebersichtAngefallenerKosten");

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_RK_Reisezeiten",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  if (checkNode("RK_Belegerkennung")) {
    kostenQuery.value = "Web_VG_UebersichtBelegeProReise";
    editAzureBeleg.value = true;
  }
  if (siteData && siteData?.zeitbereich) {
    uiData.zeitbereich = siteData.zeitbereich;
  }
  // Web_VG_UebersichtBelegeProReise
  if (siteData.aic) {
    pageParams.queryAIC = siteData.aic;
    const Stamm = globalsStt(Globals.Stt, 0, "RK_TRAVEL");
    AUApi.Current.setSyncStamm(Stamm.aic, siteData.aic);
  }
  if (siteData.zeitbereich.von) {
    day = siteData.zeitbereich.von;
  }
  myHeight = window.innerHeight;
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data) {
    refreshItems();
    addDruck();
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
function addDruck() {
  const stammTyp = globalsStt(Globals.Stt, 0, "RK_TRAVEL");
  if (stammTyp) {
    printItems = globalsDruck(Globals.Begriff, false, stammTyp);
  }
}

function refreshItems() {
  items.value = [];
  if (uiData.data.length > 0) {
    timeLine = true;
  }
  for (let i = 0; i < uiData.data.length; i++) {
    const row = uiData.data[i];
    bezeichnung = getKZValueDisplay(row, "subject", uiData.columns);
    showCalc = getKZValue(row, "showCalcHR", uiData.columns);
    let title = getKZValueDisplay(row, "abfahrt", uiData.columns);
    let title2 = getKZValueDisplay(row, "ankunft", uiData.columns);
    const subtitel = getKZValueDisplay(row, "zeit", uiData.columns);
    const subtitel1 = getKZValueDisplay(row, "ereignis", uiData.columns);
    const text = getKZValueDisplay(row, "region", uiData.columns);
    const differenz = getKZValueDisplay(row, "km", uiData.columns);
    const Abflatlong = getKZValueDisplay(row, "Abf_latlong", uiData.columns);
    if (Abflatlong) {
      title = Abflatlong[2];
    }
    const Anklatlong = getKZValueDisplay(row, "Ziel_latlong", uiData.columns);
    if (Anklatlong) {
      title2 = Anklatlong[2];
    }
    const color = getKZValueDisplay(row, "color", uiData.columns);
    const icon = getKZValueDisplay(row, "icon", uiData.columns);
    items.value.push({
      title,
      title2,
      subtitel,
      subtitel1,
      text,
      differenz,
      divider: true,
      inset: true,
      aic: row.aic_Bew_pool,
      menu: false,
      Abflatlong,
      Anklatlong,
      icon,
      color,
    });
  }
}
function onCalculated(args?: any) {
  emit("backDelete");
}
function openDruckVorschau(item: any) {
  const printItem = item;
  let aic = pageParams.queryAIC;
  if (aic) {
    aic = aic;
  }
  const noSelect = true;
  showDialog({
    title: printItem.bezeichnung,
    site: "BaseDruck",
    width: 500,
    data: {
      zeitbereich: siteData.zeitbereich,
      printItem,
      aic,
      pers: false,
      noSelect,
    },
    onClose: () => {
      showPrint = false;
      return true;
    },
  });
}
function openEditReise(aicReise: number) {
  if (!day) {
    return;
  }
  let showFullscreen = false;
  if (Constants.isMobile && isPhone()) {
    showFullscreen = true;
  }
  console.log("fullscreen: " + showFullscreen);
  const title = day.toLocaleDateString() + ": " + bezeichnung;
  showDialog({
    title,
    site: "SoftTermReisenEditReisen",
    width: 400,
    fullscreen: showFullscreen,
    data: {
      zeitbereich: siteData.zeitbereich,
      aic: aicReise,
      bewegungsdaten: true,
      showZeit: true,
    },
    onClose: (x: DialogParameter) => {
      reloadData(uiData, pageParams);
      return true;
    },
  });
}
function onReloadData(reloadData: any) {
  siteData.onReloadData = reloadData.dataSaved;
  const instance = getCurrentInstance();
  if (instance) {
    const x = instance.proxy?.$refs.kostenBelege as any;
    x?.reloadData(uiData, pageParams);
    const y = instance.proxy?.$refs.kostenKM as any;
    y?.reloadData(uiData, pageParams);
  }
}
async function onDeleteStt(modell: string) {
  if (modell) {
    const deleteOK = false;
    showSnackbar({
      text: "Wollen Sie den Datensatz wirklich löschen?",
      duration: -1,
      color: "error",
      position: "top",
      isMessage: true,
      closedManual: true,
      onClose: (sb) => {
        if (!sb.closedManual) {
          return;
        } else {
          onCalc(modell);
        }
      },
    });
  }
}
async function onCalc(modell: string) {
  if (pageParams.queryAIC) {
    const res = await calcFunctionNew(
      modell,
      pageParams.queryAIC,
      false,
      onCalculated,
      pageParams.zeitbereich,
      [],
    );
  }
  emit("backDelete");
}
function openBuchungen() {
  const mitarbeiterAIC = siteData.groupID;
  let daysForward = 3;
  let daysBack = 30;
  const vonDate = uiData.zeitbereich?.von;
  const bisDate = uiData.zeitbereich?.bis;
  const d = new Date();
  const heute = new Date(d.setHours(0, 0, 0, 0));
  const von = uiData.zeitbereich?.von.toISOString();
  const bis = uiData.zeitbereich?.bis.toISOString();
  if (vonDate && bisDate) {
    let diffDays = vonDate.getDate() - bisDate.getDate();
    if (diffDays === 0) {
      diffDays += 1;
    }
    daysForward = diffDays;
    const vonOhneUhrzeit = new Date(vonDate.setHours(0, 0, 0, 0));
    const diffToday = heute.getTime() - vonOhneUhrzeit.getTime();
    const differenceInDays = diffToday / (1000 * 3600 * 24);
    daysBack = differenceInDays + 1;
    // die Tage von Heute bis zum BEGINN der Reise berechnen um die Timeline richtig anzeihen zu können!
  }
  // const instance = getCurrentInstance();
  // if (instance) {
  //   instance.parent?.emit("back");
  // }
  // emit("back");
  onShowSite({
    title: "Buchungen",
    site: "RkAdminBuchungen",
    data: {
      zeitbereich: uiData.zeitbereich,
      goDate: von,
      aic: mitarbeiterAIC,
      name: siteData.groupName,
      daysForward,
      daysBack,
      admin: true,
    },
    callOnLeave: () => {
      return true;
    },
  });
}
</script>
<template>
  <v-card v-if="uiData.initialized" class="dvhCard" min-width="600">
    <v-toolbar
      density="compact"
      class="dvhBackground pl-5"
      style="color: white"
    >
      <div class="headline font-weight-light white--text">
        {{ bezeichnung }}
      </div>

      <v-spacer></v-spacer>
      <v-btn
        dark
        variant="text"
        @click.prevent.stop="openBuchungen()"
        icon="mdi-cog-outline"
      ></v-btn>
      <v-menu v-if="printItems">
        <template v-slot:activator="{ props }">
          <v-btn
            icon="mdi-printer-outline"
            variant="text"
            v-bind="props"
          ></v-btn>
        </template>

        <v-list lines="one" class="shortList" nav tile outlined elevation="12">
          <v-list-item
            class="pl-2"
            v-for="(printItem, ux) in printItems"
            :key="'ui' + ux"
            @click="openDruckVorschau(printItem)"
          >
            <v-tooltip
              :disabled="!printItem.tooltip"
              location="bottom"
              :text="printItem.tooltip"
            >
              <template v-slot:activator="{ props }">
                <v-list-item-title v-bind="props">
                  {{ printItem.bezeichnung }}
                </v-list-item-title>
              </template>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn dark variant="text" @click="emit('back')" icon="mdi-close"></v-btn>
    </v-toolbar>
    <v-toolbar density="compact" color="white">
      <v-spacer></v-spacer>
      <CalcButton
        :disabled="!showCalc"
        modell="RK_Web_FreigabeHR"
        color="success"
        icon="mdi-check"
        :zeitbereich="siteData.zeitbereich"
        :text="
          globalsBezeichnung(Globals.Begriff, 'RK_Web_FreigabeHR', 'bewilligt')
        "
        variant="plain"
        :modellAic="siteData.aic"
        @calculated="onCalculated"
        class="pr-2"
      />

      <CalcButton
        :disabled="!showCalc"
        modell="RK_Web_ReiseAbgelehntVG"
        color="error"
        icon="mdi-close"
        variant="plain"
        :zeitbereich="siteData.zeitbereich"
        :modellAic="siteData.aic"
        :text="
          globalsBezeichnung(
            Globals.Begriff,
            'RK_Web_ReiseAbgelehntVG',
            'abgelehnt',
          )
        "
        @calculated="onCalculated"
      />
    </v-toolbar>

    <v-divider></v-divider>
    <v-tabs v-model="tab" density="compact" tile slim show-arrows>
      <v-tab value="one">{{
        globalsBezeichnung(Globals.Begriff, "Reise", "Reise")
      }}</v-tab>
      <v-tab value="two">{{
        globalsBezeichnung(Globals.Begriff, "Memo", "Memo")
      }}</v-tab>
      <v-tab value="three">{{
        globalsBezeichnung(Globals.Begriff, "Reisezeiten", "Reisezeiten")
      }}</v-tab>
      <v-tab value="four">{{
        globalsBezeichnung(Globals.Begriff, "Web_Belege", "Belege")
      }}</v-tab>
      <v-tab value="five">{{
        globalsBezeichnung(Globals.Begriff, "RK_Auszahlung", "Diäten")
      }}</v-tab>
      <v-tab value="six">{{
        globalsBezeichnung(Globals.Begriff, "Details", "Details")
      }}</v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="one" bg-color="success">
        <BaseEditor
          query="Web_ReiseDaten_Admin"
          :zeitbereich="siteData.zeitbereich"
          :aic="siteData?.aic ?? 0"
          fieldCssClass="sm6 px-5"
          :showTitle="false"
          :showDeleteButton="true"
          :showBackButton="false"
          :maxHeight="800"
          :maxWidth="900"
          @delete="onDeleteStt('RK_Storno_Reisen')"
        />
      </v-tabs-window-item>

      <v-tabs-window-item value="two" bg-color="success">
        <BaseEditor
          query="Web_ReiseMemos_Admin"
          :zeitbereich="siteData.zeitbereich"
          :aic="siteData.aic"
          fieldCssClass="sm12"
          :showTitle="false"
          :showDeleteButton="true"
          :showBackButton="false"
          :maxWidth="600"
        />
      </v-tabs-window-item>

      <v-tabs-window-item value="three" bg-color="success">
        <v-card
          :loading="uiData.showLoading"
          v-if="uiData.initialized"
          class="dvhCard"
        >
          <v-timeline density="compact" v-if="timeLine">
            <v-timeline-item
              v-for="(item, index) in items"
              :key="'c' + index"
              size="small"
              :color="item.color"
              :icon="item.icon"
            >
              <v-card :min-width="350" class="pa-2">
                <div class="caption" style="color: green">
                  {{ item.subtitel }}
                </div>

                <v-card-text class="px-0 pb-0">
                  <div
                    style="text-align: left"
                    class="caption"
                    v-if="item.subtitel1"
                  >
                    {{
                      globalsBezeichnung(
                        Globals.Begriff,
                        "RK_REISEEREIGNISSE",
                        "Ereignis",
                      )
                    }}: {{ item.subtitel1 }}
                  </div>
                  <div
                    style="text-align: left"
                    class="caption"
                    v-if="item.title"
                  >
                    {{
                      globalsBezeichnung(
                        Globals.Begriff,
                        "Web_Abfahrt",
                        "Abfahrt",
                      )
                    }}:
                    {{ item.title }}
                  </div>
                  <div style="text-align: left" class="caption">
                    {{
                      globalsBezeichnung(
                        Globals.Begriff,
                        "Web_Zielort",
                        "Zielort",
                      )
                    }}:
                    {{ item.title2 }}
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-menu
                    open-on-click
                    top
                    offset-y
                    v-if="item.Abflatlong"
                    v-model="item.mapVisible"
                    :close-on-click="true"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ props }">
                      <v-btn
                        variant="text"
                        icon="mdi-map-marker-outline"
                        size="small"
                        v-bind="props"
                      >
                      </v-btn>
                    </template>

                    <EditGps
                      :standort="item.Abflatlong"
                      v-if="item.mapVisible"
                    ></EditGps>
                  </v-menu>
                  <v-menu
                    open-on-click
                    top
                    offset-y
                    v-if="item.Anklatlong"
                    v-model="item.mapVisible"
                    :close-on-click="true"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ props }">
                      <v-btn
                        variant="text"
                        icon="mdi-map-marker-outline"
                        size="small"
                        v-bind="props"
                      >
                      </v-btn>
                    </template>

                    <EditGps
                      :standort="item.Anklatlong"
                      v-if="item.mapVisible"
                    ></EditGps>
                  </v-menu>
                  <v-btn
                    variant="text"
                    size="small"
                    @click.prevent.stop="openEditReise(item.aic ?? 0)"
                    icon="mdi-airplane"
                  >
                  </v-btn>
                  <v-btn
                    v-if="item.aic"
                    icon="mdi-delete"
                    variant="text"
                    size="small"
                    @click="onDelete(uiData, pageParams, item.aic, modell)"
                    :disabled="item.noDelete"
                  >
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card>
      </v-tabs-window-item>

      <v-tabs-window-item value="four" bg-color="success">
        <RkAdminDialogKosten
          :query="kostenQuery"
          :zeitbereichUebergabe="siteData.zeitbereich"
          :aic="siteData.aic"
          :contentHight="myHeight"
          :edit="true"
          @onReloadData="onReloadData"
          :siteData="{
            editAzureBeleg: editAzureBeleg,
          }"
        />
      </v-tabs-window-item>

      <v-tabs-window-item value="five" bg-color="success">
        <!--Kosten der Reise-->
        <v-card>
          <RkAdminDialogKosten
            query="Web_Uebersicht_Reisekosten"
            :zeitbereichUebergabe="siteData.zeitbereich"
            :aic="siteData.aic"
            :contentHight="myHeight"
          />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="showDialogLocal = true"
              prepend-icon="mdi-information-outline"
              text="Details"
            >
            </v-btn>
            <v-dialog
              v-model="showDialogLocal"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
              scrollable
            >
              <v-card>
                <BaseVGrid
                  v-if="uiData.initialized"
                  query="Web_Uebersicht_Reisekosten"
                  :zeitbereich="siteData.zeitbereich"
                  :queryAic="siteData.aic"
                  :showClose="true"
                  @back="showDialogLocal = false"
                ></BaseVGrid>
              </v-card>
            </v-dialog>
          </v-card-actions>
        </v-card>
      </v-tabs-window-item>

      <v-tabs-window-item value="six" bg-color="success">
        <BaseEditor
          query="Web_ReiseDatenVG_Details"
          :zeitbereich="siteData.zeitbereich"
          :aic="siteData.aic"
          fieldCssClass="sm12"
          :showTitle="false"
          :showDeleteButton="false"
          :showBackButton="false"
        />
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>

<style scopes>
.dvhCard {
  margin-bottom: 0px;
  width: 100%;
  padding: 0 0 0 0;
  overflow-y: scroll;
}
</style>
